import React, { useRef, useState, useEffect } from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Grid} from '@mui/joy';
import ProgressBar from "./ProgressBar";
import { Button, Typography } from "@mui/material";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from './styles'
// import DoughnutChartWithSliders from "./DoughnutChartWithSliders";

const Answer = (props) => {
  const { setCurrentScreen, question, answers } = props
  const { Title, QuestionMarkers, ActualText, ActualColor, ScoreText, ScorePercentage, NextButton, ScorePercentageContainer, DescriptionText, LeftGrid } = styles;
  const maxNumber = Math.max(...(Object.values(answers)), ...(Object.values(question.actual)));
  let maxWidth = 80 / maxNumber; //slider length calculation.

  const calculatePercentage = () => {
    let answerPercentage = 0
    let avgSliderValue = 100 / 5;
    let keys = Object.keys(question.actual);
    for (let i = 0; i < 5; i++) {
      let difference = Math.abs(question.actual[keys[i]] - answers[keys[i]])
      answerPercentage += difference < 2 ? avgSliderValue : avgSliderValue - (difference - 1) >= 0 ? avgSliderValue - (difference - 1) : 0
      // difference = difference > 8 ? 0 : difference;
      // console.log("difference", difference)
      // answerPercentage += (8 - difference) * (avgSliderValue / 8);
    }
    return Math.round(answerPercentage);
  }
  return(
    <Grid container alignItems={'center'} justifyContent={'center'}>
      <LeftGrid container spacing={2} xs={12} justifyContent={'center'}>
        <Grid container xs={6} md={6}>
          <Title>
            {question.title}
            <Tooltip title="Source: Tax Policy Center (Urban Institute and Brookings Institution)">
              <IconButton>
                <QuestionMarkers />
              </IconButton>
            </Tooltip>
          </Title>
          <Grid xs={12} container justifyContent={'center'}>
            <Grid xs={2}></Grid>
            <Grid container xs={3}>
              <ActualText >ACTUAL</ActualText>
              <ActualColor style={{ backgroundColor: "#003e4c" }} />
            </Grid>
            <Grid container xs={3}>
            <ActualText>GUESS</ActualText>
            <ActualColor style={{ backgroundColor: "#00b1d9" }} />
            </Grid>
            <Grid xs={4}></Grid>
          </Grid>

          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Top"]} guess={answers['Top']} value={question.actual['Top']} name={"Top 20%"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Second"]} guess={answers['Second']} value={question.actual['Second']} name={"Second 20%"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Middle"]} guess={answers['Middle']} value={question.actual['Middle']} name={"Middle 20%"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Fourth"]} guess={answers['Fourth']} value={question.actual['Fourth']} name={"Fourth 20%"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Bottom"]} guess={answers['Bottom']} value={question.actual['Bottom']} name={"Bottom 20%"} />
        </Grid>
        <Grid container xs={4} justifyContent={'center'} alignItems={'center'} style={{ flexDirection: 'column' }}>
          <Grid container xs={12} justifyContent={'center'} alignItems={'center'}>
          <ScoreText>YOUR SCORE</ScoreText>
            <ScorePercentageContainer container>
              <ScorePercentage>
              {calculatePercentage()}%
              </ScorePercentage>
              </ScorePercentageContainer>
            <DescriptionText>{question.description}</DescriptionText>
          </Grid>
        </Grid>
        <Grid container xs={1}></Grid>
      </LeftGrid>
      <NextButton
      onClick={() => setCurrentScreen("Question")}
       >RESTART</NextButton>
    </Grid>
  )
}

// Use it if you don't plan to use "remount"
// document.addEventListener('DOMContentLoaded', () => {
  // ReactDOM.render(, document.getElementById('hello'))
// })

export default Answer
